import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Navigation from 'components/Navigation';

import styles from './app.scss';

function App({ children }) {
  return (
    <div>
      <Helmet titleTemplate="BLUEMAC: %s">
        <title>BLUEMAC</title>
        <meta name="description" content="The BLUEMAC dashboard" />
        <meta property="og:site_name" content="BLUEMAC Starter Kyt" />
        <meta property="og:image" content="" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="BLUEMAC React Universal Starter Kyt" />
        <meta
          property="og:description"
          content="A starter kyt with React, Redux, SSR and data fetching."
        />
        <meta property="og:card" content="summary" />
        <meta property="og:site" content="@cleverfranke" />
        <meta property="og:creator" content="@cleverfranke" />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="200" />
      </Helmet>

      <header className={styles.header}>
        <Navigation />
      </header>

      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
}
App.propTypes = {
  children: PropTypes.node.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js